var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContainerFlat',[_c('v-card-text',{staticClass:"d-flex align-center"},[_c('v-avatar',{staticClass:"ma-auto",class:{'invert-color': _vm.invertColor},attrs:{"size":"100"}},[_c('v-img',{attrs:{"src":require("../assets/loading.gif")}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }